<template>
  <SSection
    v-if="item.seoLinks && item.seoLinks.nearbyVillages.length > 0"
    :title="t('views.cottage.seoLinks.nearbyVillagesTitle')"
  >
    <SLinks :items="items"></SLinks>
  </SSection>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'
import type { propsInterface as SLinksPropsInterface } from '~/modules/design-system/sections/s-links/s-links.vue'

type itemType = {
  seoLinks: Pick<NonNullable<CottagePage['seoLinks']>, 'nearbyVillages'> | null
}

interface propsInterface {
  item: itemType
}

const props = defineProps<propsInterface>()

let items: SLinksPropsInterface['items'] = []

if (props.item?.seoLinks?.nearbyVillages) {
  items = props.item.seoLinks.nearbyVillages?.map(link => {
    return {
      name: link.name,
      href: link.url,
    }
  })
}
</script>
